module.exports = __webpack_public_path__ + "static/img/头像6.d94b1e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/头像6.png
// module id = D/ns
// module chunks = 1